import Media from 'client/common/components/media';

import './Media.css';

export default Media;
